(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.as-cart-banner__tooltip-trigger');

    if (trigger) {
      e.stopPropagation();
      var wrapper = trigger.closest('.as-cart-banner__tooltip-wrapper');
      var isActive = wrapper.classList.toggle('as-is-active');
      trigger.setAttribute('aria-expanded', String(isActive));
      return;
    }

    if (!e.target.closest('.as-cart-banner__tooltip-wrapper')) {
      document.querySelectorAll('.as-cart-banner__tooltip-wrapper.as-is-active').forEach(function (el) {
        el.classList.remove('as-is-active');
        var btn = el.querySelector('.as-cart-banner__tooltip-trigger');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.as-cart-banner__tooltip-wrapper.as-is-active').forEach(function (el) {
      el.classList.remove('as-is-active');
      var btn = el.querySelector('.as-cart-banner__tooltip-trigger');
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  });
})();
